import React, { ReactElement, useEffect } from 'react';
import { BaseEntite, BaseEntiteStatique } from '../../../../../common/src/entities';
import { useEntite } from '../../../Utils/api';

export interface PropsDeAprecuApercuEntiteFromRequest<TEntite extends BaseEntite> {
    entite: BaseEntiteStatique<TEntite>,
    id: number,
    notifyRequestResponse: (entiteFromResponse: TEntite) => void,
};

export default function ApercuEntiteFromRequest<TEntite extends BaseEntite>(props: PropsDeAprecuApercuEntiteFromRequest<TEntite>): ReactElement {
    const {
        entite,
        id,
        notifyRequestResponse
    } = props;

    const { data } = useEntite(entite, id);

    useEffect(() => {
        if (data) {
          notifyRequestResponse(data as TEntite);
        }
    }, [data]);

    return <strong>{"Chargement de l'aperçu..."}</strong>
};

